import Fetcher from '../../services/Fetcher'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination,
  TOptionsResponse
} from '../../constants'
import {
  TContractsCategoriesListRequest,
  TContractCategoriesList,
  TContractsCategoriesReassignResponsibleData
} from './types'
import { IPartialUserInfo } from '../../redux/store/user/types'

const fetcher = new Fetcher({})

export const getContractsCategoriesList = async (data) =>
  fetcher.request<
    TContractsCategoriesListRequest,
    ResponseWithPagination<TContractCategoriesList>
  >({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.CATEGORIES}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const reassignResponsible = async (
  uuid: string,
  data: TContractsCategoriesReassignResponsibleData
) =>
  fetcher.request<
    TContractsCategoriesReassignResponsibleData,
    TContractsCategoriesReassignResponsibleData
  >({
    url: `${API_DICTIONARY.CONTRACT_CATEGORIES}${uuid}/${API_DICTIONARY.SOURCING_SIDE}${API_DICTIONARY.ASSIGN}`,
    method: HTTP_METHODS.POST,
    data
  })

export const getTeamResponsibleForReassign = async ({ uuid, hsId }) =>
  fetcher.request<
    { health_system: string },
    ResponseWithPagination<IPartialUserInfo>
  >({
    url: `${API_DICTIONARY.CONTRACT_CATEGORIES}${uuid}/${API_DICTIONARY.OPTIONS}${API_DICTIONARY.SOURCING_USERS}`,
    method: HTTP_METHODS.GET,
    params: {
      health_system: hsId
    }
  })

export const getStatusFilterOptions = async () =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.CATEGORIES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.STATUS}`,
    method: HTTP_METHODS.GET
  })
